require('Modernizr');
// require('bootstrap');
require('jquery-match-height');
require('select2');

import { debounce } from 'lodash';

$(document).on('ready', () => {
	$('.matchheight').matchHeight();

	$('.select2 > select').select2({
		minimumResultsForSearch: Infinity
	});

	$('.filter.select2 > select').on('change', function() {
		window.location.assign($(this).val());
	});

	$('#mobile-toggle').on('click', function() {
		let $this = $(this);

		$this.toggleClass('on');
		$('nav.navbar.yamm').toggleClass('shown');
		$('body').toggleClass('mobile-nav-open');
	});

	$('.search input').attr('autocomplete', 'off');
	
	$('.search-icon').on('click', () => {
		$('.search-input').toggleClass('search-expand');
	});

	$('.two-column-layout-imageedge').each(function() {
		let $section = $(this);
		let $leftCol = $section.find('.left-column');
		let $rightCol = $leftCol.siblings().first();
		const offset = 30;

		let sizeElementToAnother = function() {
			if (window.screen.width > 992) {
				if ($leftCol.outerHeight() > $rightCol.outerHeight()) {
					$rightCol.css('height', $leftCol.outerHeight() - offset);
				} else {
					$rightCol.css('height', 'auto');
				}
			} else {
				$rightCol.css('height', 'auto');
			}
		}

		sizeElementToAnother($leftCol, $rightCol, 30);

		$(window).on('resize', debounce(sizeElementToAnother, 150));
	})

	// $('ul.sub-menu').each(function () {
	// 	console.log('sub menu positioning set up function');
	// 	let $dropdown = $(this);
	// 	let $parentLi = $dropdown.parent('li');
	// 	let dropdownRect = $dropdown.get(0).getBoundingClientRect();
		
	// 	let positionAbsoluteToRightOfWindow = function() {
	// 		console.log('positioning function');
	// 		let htmlWidth = document.querySelector('html').clientWidth;
	// 		let parentRect = $($parentLi).get(0).getBoundingClientRect();
	// 		console.log($dropdown, dropdownRect, parentRect, window.innerWidth);
	// 		if (htmlWidth >= 1200 && dropdownRect.right > htmlWidth) {
	// 			console.log('needs repositioning');
	// 			$dropdown.css('right', '-'+ (htmlWidth - parentRect.right) + 'px')
	// 				.css('transform', 'translateX(0)')
	// 				.css('max-width', htmlWidth + 'px')
	// 				.css('width', htmlWidth + 'px')
	// 				.addClass('limited-to-screen');
	// 		} else {
	// 			console.log('no repositioning needed');
	// 			$dropdown.removeAttr('style').removeClass('limited-to-screen');
	// 		}
	// 	}

	// 	positionAbsoluteToRightOfWindow();

	// 	$(window).on('resize', debounce(positionAbsoluteToRightOfWindow, 150))
	// })

	// Secondary menu smooth slide
	$('.secondarymenu').on('click', 'a[href*="#"]:not([href="#"])', function() {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - 120
				}, 1000);
				return false;
			}
		}
	});
});

function initNavToggles() {
	let menuWrapper = document.querySelector('.main-menu-wrapper');
	let menuContainer = document.querySelector('.main-menu-container');
	let menu = document.querySelector('.menu.tfa-header-menu');
	let dropdownLis = menu.querySelectorAll(':scope > .has-sub-menu');
	let backNavButton = document.querySelector('.sub-menu-back-nav');
	
	if (dropdownLis.length == 0) {
		return false
	}
	
	backNavButton.addEventListener('click', function(e) {
		let activeContentArea = menu.querySelector(':scope .yamm-content.open');

		menuContainer.classList.remove('sub-menu-open');
		menuWrapper.classList.remove('sub-menu-open');

		setTimeout(() => {
			activeContentArea.classList.remove('open');
			
			// resets height of menuwrapper
			menuWrapper.style.height = 'unset';
		}, 300);

		e.preventDefault();
	})
	
	dropdownLis.forEach(function(element, index, list) {
		// expecting element to be an li element - li.dropdown. 
		// should have a direct child a tag with a direct child .sub-menu-toggle
		let button = element.querySelector(':scope > a > .sub-menu-toggle');
		let contentArea = element.querySelector(':scope > .yamm-content');
		let siblings = [...element.parentElement.children];

		button.addEventListener('click', function(e) {
			menuWrapper.classList.add('sub-menu-open');
			menuContainer.classList.add('sub-menu-open');
			contentArea.classList.add('open');

			// sets height of menuwrapper to height of contentarea to avoid scrollbar
			menuWrapper.style.setProperty('height', String(contentArea.scrollHeight) + 'px');
			e.preventDefault();
		});
	})
}

function clearexpanded() {
	let width = window.innerWidth;
	
	if (width > 1200) {
		let expanded = document.querySelectorAll('.has-sub-menu.expanded');
		
		expanded.forEach(function(element) {
			element.classList.remove('expanded');
		})
	}
}

function initPage() {
	initNavToggles();
	window.addEventListener('resize', clearexpanded);
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	document.addEventListener("DOMContentLoaded", initPage);
} else {
	// `DOMContentLoaded` has already fired
	initPage();
}